/**
 * This bootstrap file is used for both frontend and core
 */

import _ from 'lodash'
import axios from 'axios'
import Swal from 'sweetalert2';
import $ from 'jquery';
import 'popper.js'; // Required for BS4
import 'bootstrap';
import {getStoredTranslations} from './app/Helpers/LocalizationHelper';

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

window.$ = window.jQuery = $;
window.Swal = Swal;
window._ = _; // Lodash
window.moment = require('moment')

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = axios.create({
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content'),
        'Access-Control-Allow-Origin': '*'
    }
})

const getTranslations = () => {
    return getStoredTranslations();
};

const translate = (key, fallback, replacements = {}) => {
    let message = getTranslations()?.[key] || fallback;

    Object.entries(replacements).forEach(([replacementKey, value]) => {
        message = message.replace(`:${replacementKey}`, value);
    });

    return message;
};

const appendSupportHint = (message) => {
    const supportEmail = window.supportContact?.email;

    if (supportEmail) {
        return `${message} ${translate('contact_support_at_email', 'If the issue persists, contact support at :email.', {email: supportEmail})}`.trim();
    }

    return `${message} ${translate('contact_support_if_issue_persists', 'If the issue persists, contact support.')}`.trim();
};

window.axios.interceptors.response.use(
    response => response,
    error => {
        if (!error.response) {
            error.response = {
                status: 0,
                data: {
                    status: false,
                    supportAction: true,
                    message: appendSupportHint(
                        translate(
                            'network_error_message',
                            'Unable to reach the server right now.'
                        )
                    ),
                },
            };

            return Promise.reject(error);
        }

        const { status } = error.response;

        if (!error.response.data || typeof error.response.data !== 'object' || Array.isArray(error.response.data)) {
            error.response.data = { status: false };
        }

        if (!error.response.data.message) {
            switch (status) {
                case 400:
                    error.response.data.message = translate('bad_request_error_message', 'The request could not be processed.');
                    break;
                case 401:
                    error.response.data.message = translate('unauthorized_error_message', 'Your session is no longer valid. Please sign in again.');
                    break;
                case 403:
                    error.response.data.message = translate('forbidden_error_message', 'You are not allowed to access this resource.');
                    break;
                case 404:
                    error.response.data.message = translate('not_found_error_message', 'The requested resource could not be found.');
                    break;
                case 419:
                    error.response.data.message = translate('csrf_token_mismatch_message', 'Please refresh the page and try again.');
                    break;
                case 429:
                    error.response.data.message = translate('too_many_requests_error_message', 'Too many requests. Please try again shortly.');
                    break;
                case 500:
                case 502:
                case 504:
                    error.response.data.message = appendSupportHint(
                        translate('server_error_message', 'An internal error occurred on our side.')
                    );
                    error.response.data.supportAction = true;
                    break;
                case 503:
                    error.response.data.message = appendSupportHint(
                        translate('service_unavailable_error_message', 'The service is temporarily unavailable.')
                    );
                    error.response.data.supportAction = true;
                    break;
                default:
                    error.response.data.message = translate('failed_response', 'Something went wrong');
                    break;
            }
        }

        return Promise.reject(error);
    }
);

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
